import { DEFAULT_CLUSTER_CONNECTIONS, type ClusterConnections } from 'config/index';
import { client } from 'modules/Apollo/client';
import { createApolloLink } from 'modules/Apollo/links';
import { useEffect } from 'react';
import { priorClient } from 'modules/Apollo/priorClient';
import analytics from 'modules/analytics';
import { globalContext } from 'modules/analytics/constants';

/**
 * @deprecated until future clusters become active with a switch-over option.
 * dynamic re-configuration of configured external connections
 * Use `useConnectionUrls()` instead to get one-time urls
 */
export function useClusterRedirects() {
  useEffect(() => {
    setClusterConnections();
  }, []);
}

/**
 * @deprecated until future clusters become active with a switch-over option.
 * This function manages dynamic configuration and switchover to a different cluster.
 */
export function setClusterConnections() {
  const setTargets = (clusterConnections: ClusterConnections) => {
    client.setLink(
      createApolloLink({
        httpUri: clusterConnections.graphqlUrl,
        wsUri: clusterConnections.graphqlWs,
      })
    );
    priorClient.setLink(
      createApolloLink({
        httpUri: clusterConnections.graphqlUrl,
        wsUri: clusterConnections.graphqlWs,
      })
    );
  };

  setTargets(DEFAULT_CLUSTER_CONNECTIONS);
  analytics.addContext(globalContext.workspace.clusterConnection, 'main');
}

/**
 * returns a set of urls dependent on current hostname
 * to auto-match regional clusters
 */
export function useConnectionUrls() {
  return DEFAULT_CLUSTER_CONNECTIONS;
}
